import { checkListSchema } from "features/common/schemas";
import { denormalize } from "normalizr";
import { createSelector } from "reselect";
import { emptyArray } from "constants/emptyConst";

const DEFAULT_DATA = Object.assign([], { loading: true, loaded: false });
const selectCheckListFlags = (state, id) => state.document.checklist[id];
const selectCheckListState = (state, id) => denormalize(id, checkListSchema, state.entities);

export const selectCheckList = createSelector([selectCheckListState, selectCheckListFlags], (checklist, flags) => {
  if (!flags || !flags.loaded || flags.loading) return DEFAULT_DATA;
  return { ...checklist, ...flags };
});

const selectChecklistsState = state => state.dictionaries.checklists;

export const selectChecklistsLoaded = createSelector(
  [selectChecklistsState],
  checklists => checklists && checklists.isLoaded
);

export const selectChecklists = createSelector(
  [selectChecklistsState, selectChecklistsLoaded],
  (checklists, isLoaded) => (isLoaded ? Object.keys(checklists.items).map(key => checklists.items[key]) : emptyArray)
);
